import { type Ref, watch, onMounted, nextTick } from 'vue';
import { hydrateIndmoRichTextIcons } from '@/utils/indmoLucideIcons';
import { onOfflineMediaImgError } from '@/utils/offlineMediaPlaceholder';

function attachRichTextImageFallbacks(root: HTMLElement | null): void {
  if (!root) return;
  root.querySelectorAll('img[src]').forEach((node) => {
    const img = node as HTMLImageElement;
    if (img.dataset.indmoImgFallbackBound === '1') return;
    img.dataset.indmoImgFallbackBound = '1';
    img.addEventListener('error', onOfflineMediaImgError, { once: true });
  });
}

/**
 * After `v-html` updates, render inline Lucide icons for Wagtail `indmo_icon` entities.
 */
export function useIndmoRichTextIcons(
  rootRef: Ref<HTMLElement | null | undefined>,
  source: () => unknown
): void {
  function paint() {
    nextTick(() => {
      const el = rootRef.value ?? null;
      hydrateIndmoRichTextIcons(el);
      attachRichTextImageFallbacks(el);
    });
  }
  onMounted(paint);
  watch(source, paint);
}
